import { render, staticRenderFns } from "./ListManager.vue?vue&type=template&id=520d6370&scoped=true"
import script from "./ListManager.vue?vue&type=script&lang=js"
export * from "./ListManager.vue?vue&type=script&lang=js"
import style0 from "./ListManager.vue?vue&type=style&index=0&id=520d6370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d6370",
  null
  
)

export default component.exports